export const environment = {
  production: false,
  //dns: "http://localhost:8080/",
  dns: "https://tms.rimtrack.com/ws_menara/",
  nominatim_dns: "/nominatim/",
  imagesPOIDir: "/images/poi/",
  lastUpdate: new Date("2026/07/28")
};
